export const isValidDate = (dateString: string | Date) => {
  const MIN_YEAR = 1900;

  const date = new Date(dateString);
  const isValid = !isNaN(date.getTime()) && date.getFullYear() >= MIN_YEAR;
  return isValid;
};
